import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const BRAND = {
  name: "VIS DE ZI",
  slogan: "COLOREAZĂ. RESPIRĂ. VISEAZĂ.",
  tagline: "O oră doar pentru tine.",
  creator: "Alina Stancu",
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/a49z6gf3_LOGO.jpeg",
  cover: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/sswcfac4_COVER%20UP%20RO.png",
  mockup: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/kai1xdai_CARTE%20MOCK.jpeg",
  interiorMermaid: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/36c4aiuj_2.jpeg",
  interiorFashion: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/96guugtb_MOCK.jpeg",
  halloweenCover: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/5woa5ck3_COPERTA%20NOUA%20FATA.png",
  pageColoredPink: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/hfz2wlco_WhatsApp%20Image%202026-10-01%20at%2019.36.01.jpeg",
  pagePolkaDot: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/ve0jf0po_4.jpeg",
  pagePeonies: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/hro52x6o_3.jpeg",
  pageGeisha: "https://customer-assets-lxgj4vgw.emergentagent.net/job_vis-de-zi/artifacts/docwyywt_WhatsApp%20Image%202026-10-01%20at%2019.38.28.jpeg",
  social: {
    instagram: "https://instagram.com/visde_zi",
    tiktok: "https://tiktok.com/@vis.de.zi",
    facebook: "https://facebook.com/visdezi",
  },
};

export const JUDETE = [
  "Alba","Arad","Argeș","Bacău","Bihor","Bistrița-Năsăud","Botoșani","Brașov","Brăila",
  "București","Buzău","Caraș-Severin","Călărași","Cluj","Constanța","Covasna","Dâmbovița",
  "Dolj","Galați","Giurgiu","Gorj","Harghita","Hunedoara","Ialomița","Iași","Ilfov",
  "Maramureș","Mehedinți","Mureș","Neamț","Olt","Prahova","Satu Mare","Sălaj","Sibiu",
  "Suceava","Teleorman","Timiș","Tulcea","Vaslui","Vâlcea","Vrancea",
];

export const fmtRON = (n) => `${Number(n).toFixed(0)} RON`;
